import { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useTranslation } from "react-i18next";

// npm packages
import { Navbar, Nav, Container } from "react-bootstrap";

// assets
import { Menu } from "../assets/img/sources/Menu";

// project imports
import { LanguageSwitcher } from "./LanguageSwitcher";
import { ThemeToggle } from "./ThemeToggle";

import "./Navbar.css";
import { Logo } from "../assets/img/sources/Logo";

export const NavBar = () => {
  const { t } = useTranslation();
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

useEffect(() => {
  const onScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }

    // Update activeLink based on scroll position
    if (window.scrollY < document.getElementById('about').offsetTop) {

      setActiveLink('home');
    } else if (window.scrollY < document.getElementById('technologies').offsetTop) {
      setActiveLink('about');
    } else if (window.scrollY < document.getElementById('projects').offsetTop) {
      setActiveLink('technologies');
    } else if (window.scrollY < document.getElementById('contact').offsetTop) {
      setActiveLink('projects');
    } else {
      setActiveLink('contact');
    }
  };

  window.addEventListener("scroll", onScroll);

  return () => window.removeEventListener("scroll", onScroll);
}, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  return (
    <Router>
      <Navbar expand="md" className={`${scrolled ? "scrolled" : ""} ${isExpanded ? "expanded" : ""}`}>
        <Container>
          <Navbar.Brand href="#home">
            <Logo size={"2rem"} />
          </Navbar.Brand>
          <Navbar.Toggle
            onClick={handleToggle}
            aria-controls="basic-navbar-nav"
          >
            <Menu size="1.5rem" />
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link
                href="#home"
                active={false}
                className={
                  activeLink === "home" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("home")}
              >
                {t("navbar.home")}
              </Nav.Link>
              <Nav.Link
                href="#about"
                active={false}
                className={
                  activeLink === "about" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("skills")}
              >
                {t("navbar.about")}
              </Nav.Link>
              <Nav.Link
                href="#technologies"
                active={false}
                className={
                  activeLink === "technologies"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("technologies")}
              >
                {t("navbar.technologies")}
              </Nav.Link>
              <Nav.Link
                href="#projects"
                active={false}
                className={
                  activeLink === "projects"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("projects")}
              >
                {t("navbar.projects")}
              </Nav.Link>
              <Nav.Link
                href="#contact"
                active={false}
                className={
                  activeLink === "contact"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("contact")}
              >
                {t("navbar.contact")}
              </Nav.Link>
            </Nav>

            <LanguageSwitcher />
            <ThemeToggle />
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  );
};
